<template>
  <page :head-text="$t('profile.profile')" head-uppercase>
    <template #leftBtn>
      <scan-code v-if="!tempAccess && !isBodyAi" @click="launchQrScan" />
    </template>
    <template #rightBtn>
      <div v-if="isBodyAi" class="p-1" @click="goToChat">
        <CloseIcon class="close-icon" />
      </div>
      <show-menu v-else @click="$emit('menu')" />
    </template>
    <div class="profile-wrapper mt-16 mb-auto flex flex-col justify-start items-center">
      <avatar :src="avatarSrc" show-edit @click="$emit('edit-profile')" />
      <div v-if="profile.nick_name" class="mt-4 text-xl">{{ profile.nick_name }}</div>
      <div v-if="auth.username" class="username mt-1 text-xs">{{ auth.username }}</div>
      <menu-list class="mt-12" :sort-menu="menuList" @menu="handleMenuItem" />
      <menu-item v-if="!isBodyAi" :item="scanQrMenuItem" @click="launchQrScan" />
    </div>
    <bottom-nav
      v-if="!isBodyAi"
      :fixed="true"
      :can-scan="canScan"
      :has-rmd-sizes="hasRmdSizes"
      :active-page="activePage"
      @changed="$emit('update:active-page', $event)"
    />
  </page>
</template>

<script>
import { mapActions } from 'vuex';
import page from '@/mixins/page';
import showAvatar from '@/mixins/show-avatar';
import scanImg from '@/assets/common/menu-scan.svg';
import Avatar from '@/components/common/Avatar.vue';
import ScanCode from '@/components/common/ScanCode.vue';
import ShowMenu from '@/components/common/ShowMenu.vue';
import Page from '@/components/DefaultCloudzet/HomePage/Page.vue';
import BottomNav from '@/components/DefaultCloudzet/HomePage/BottomNav.vue';
import MenuList from '@/components/DefaultCloudzet/common/MenuList.vue';
import MenuItem from '@/components/DefaultCloudzet/common/MenuItem.vue';
import CloseIcon from '@/components/common/svg/Close.vue';

export default {
  mixins: [page, showAvatar],
  components: {
    Page,
    MenuList,
    Avatar,
    MenuItem,
    BottomNav,
    ScanCode,
    ShowMenu,
    CloseIcon,
  },
  props: {
    profile: Object,
    canScan: Boolean,
    recordToShow: Boolean,
    hasRmdSizes: Boolean,
    tempAccess: Boolean,
    auth: Object,
    activePage: {
      type: String,
      default: 'measurement',
    },
  },
  inject: ['isBodyAi'],
  methods: {
    ...mapActions('app', ['launchQrScan']),
    handleMenuItem(menuItem) {
      if (menuItem.pageName === 'user-setting') {
        this.$emit('menu', { ...menuItem, directOpen: true });
      } else {
        this.$emit('menu', menuItem);
      }
    },
    goToChat() {
      this.$events.goto('BodyAiChat');
    },
  },
  computed: {
    scanQrMenuItem() {
      return {
        img: scanImg,
        name: this.$t('homePage.scan_to_login'),
      };
    },
    menuList() {
      return [
        // 'avatar-shader',  TODO: add this
        'user-setting',
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  color: var(--primary-text, #262626);

  .username {
    color: var(--secondary-text, #fff);
  }
}
.close-icon {
  color: #fff;
}
</style>
